import {Component, OnInit, Input} from '@angular/core';
import {APPCONFIG} from "../../config";

@Component({
  selector: 'app-syllabus-curriculum',
  templateUrl: './syllabus-curriculum.component.html',
  styleUrls: ['./syllabus-curriculum.component.scss']
})
export class SyllabusCurriculumComponent implements OnInit {
  @Input() curriculumUnit;
  AppConfig: any;

  constructor() { }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-curriculum/syllabus-curriculum.component.ts